import { z } from 'zod'

export const rosterSearchSchema = z.object({
  /** Opens the create view; `library` also ticks "Save to the Talent Library". */
  create: z.enum(['roster', 'library']).optional().catch(undefined),
})

export type RosterSearch = z.infer<typeof rosterSearchSchema>
